export default {
  respondComment: 'پاسخ دادن نظر',
  commentResponseSubmittedSuccessfylly: 'پاسخ نظر با موفقیت ثبت شد',
  changeCommentState: 'تغییر وضعیت نظر',
  commentStateChangedSuccessfylly: 'وضعیت نظر با موفقیت تغییر کرد',
  draft: 'پیش نویس',
  saveAsDraft: 'ذخیره به عنوان پیش نویس',
  postPublishedSuccessfully: 'پست با موفقیت منتشر شد',
  studyDurationMinute: 'زمان مطالعه',
  likeCount: 'تعداد لایک'
}
